import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
// import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from '../../utils/API/requestMiddleware';
import AddApplication from '../../features/configuration/component/AddApplication';
// import { encryptUrlData } from '../../services/CryptoService';

const configurationAPI = createApi({
    baseQuery: defautBaseQuery, // Replace with your API endpoint
    reducerPath: 'configurationAPI',
    endpoints: (builder) => ({

        getAllChemPropertyMaster: builder.query({
            query: () => ({
                url: '/Configuration/GetAllChemPropertyMaster',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllPrecautionStatements: builder.query({
            query: () => ({
                url: '/Configuration/GetAllPrecautionStatements',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllPictogramAsset: builder.query({
            query: () => ({
                url: '/Configuration/GetAllPictogramAsset',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllHazardStatements: builder.query({
            query: () => ({
                url: '/Configuration/GetAllHazardStatements',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllSynonymTypes: builder.query({
            query: () => ({
                url: '/Configuration/GetAllSynonymTypes',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllSafetyHazardTypes: builder.query({
            query: () => ({
                url: '/Configuration/GetAllSafetyHazardTypes',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllSchedulers: builder.query({
            query: () => ({
                url: '/Configuration/GetAllSchedulers',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addNewPropertyToMaster: builder.mutation({
            query: (details) => ({
                url: '/Configuration/AddNewPropertyToMaster',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addNewScheduler: builder.mutation({
            query: (details) => ({
                url: '/Configuration/AddNewScheduler',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addNewPictogramAssetToMaster: builder.mutation({
            query: (details) => ({
                url: '/Configuration/AddNewPictogramAssetToMaster',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addNewHazardStatement: builder.mutation({
            query: (details) => ({
                url: '/Configuration/AddNewHazardStatement',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addNewPrecautionStatement: builder.mutation({
            query: (details) => ({
                url: '/Configuration/AddNewPrecautionStatement',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addNewSynonymType: builder.mutation({
            query: (details) => ({
                url: '/Configuration/AddNewSynonymType',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addNewSafetyHazardType: builder.mutation({
            query: (details) => ({
                url: '/Configuration/AddNewSafetyHazardType',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateChemPropertyMaster: builder.mutation({
            query: (details) => ({
                url: '/Configuration/UpdateChemPropertyMaster',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateScheduler: builder.mutation({
            query: (details) => ({
                url: '/Configuration/UpdateScheduler',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updatePrecautionStatement: builder.mutation({
            query: (details) => ({
                url: '/Configuration/UpdatePrecautionStatement',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updatePictogramAsset: builder.mutation({
            query: (details) => ({
                url: '/Configuration/UpdatePictogramAsset',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateHazardStatement: builder.mutation({
            query: (details) => ({
                url: '/Configuration/UpdateHazardStatement',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateSynonymType: builder.mutation({
            query: (details) => ({
                url: '/Configuration/UpdateSynonymType',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateSafetyHazardType: builder.mutation({
            query: (details) => ({
                url: '/Configuration/UpdateSafetyHazardType',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllPatterns: builder.query({
            query: () => ({
                url: '/Configuration/GetAllPatterns',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addNewPattern: builder.mutation({
            query: (details) => ({
                url: '/Configuration/AddNewPattern',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updatePattern: builder.mutation({
            query: (details) => ({
                url: '/Configuration/UpdatePattern',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addThirdPartyApplication: builder.mutation({
            query: (data) => ({
                url: '/Configuration/AddThirdPartyApplication',
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getListThirdPartyApplications: builder.query({
            query: () => ({
                url: '/Configuration/GetListThirdPartyApplications',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateThirdPartyApplication: builder.mutation({
            query: (data) => ({
                url: '/Configuration/UpdateThirdPartyApplication',
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getThirdPartyApplicationDetailByAppId: builder.query({
            query: (thirdPartyAppId) => ({
                url: encryptQueryString(`/Configuration/GetThirdPartyApplicationDetailByAppId?ThirdPartyAppId=${thirdPartyAppId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getListThirdPartyAppWisePropertyMapByAppId: builder.query({
            query: (thirdPartyAppId) => ({
                url: encryptQueryString(`Configuration/GetListThirdPartyAppWisePropertyMapByAppId?ThirdPartyAppId=${thirdPartyAppId}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteThirdPartyAppWisePropertyMap: builder.mutation({
            query: ({ appWisePropertyId, deletedBy }) => ({
                url: encryptQueryString(`/Configuration/DeleteThirdPartyAppWisePropertyMap?appWisePropertyId=${appWisePropertyId}&deletedBy=${deletedBy}`),
                method: "DELETE",
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getPropertyTypeList: builder.query({
            query: () => ({
                url: 'Configuration/GetPropertyTypeList',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getPropertyListByPropertyTypeId: builder.query({
            query: (propertyTypeId) => ({
                url: `Configuration/GetPropertyListByPropertyTypeId?PropertyTypeId=${propertyTypeId}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addThirdPartyAppWisePropertyMap: builder.mutation({
            query: (data) => ({
                url: 'Configuration/AddThirdPartyAppWisePropertyMap',
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        })
    })
});

export const {
    useLazyGetAllChemPropertyMasterQuery,
    useLazyGetAllPrecautionStatementsQuery,
    useLazyGetAllPictogramAssetQuery,
    useLazyGetAllHazardStatementsQuery,
    useLazyGetAllSynonymTypesQuery,
    useLazyGetAllSafetyHazardTypesQuery,
    useAddNewPropertyToMasterMutation,
    useAddNewPictogramAssetToMasterMutation,
    useAddNewHazardStatementMutation,
    useAddNewPrecautionStatementMutation,
    useAddNewSynonymTypeMutation,
    useAddNewSafetyHazardTypeMutation,
    useUpdateChemPropertyMasterMutation,
    useUpdatePrecautionStatementMutation,
    useUpdatePictogramAssetMutation,
    useUpdateHazardStatementMutation,
    useUpdateSynonymTypeMutation,
    useUpdateSafetyHazardTypeMutation,
    useLazyGetAllSchedulersQuery,
    useAddNewSchedulerMutation,
    useUpdateSchedulerMutation,
    useAddThirdPartyApplicationMutation,
    useLazyGetListThirdPartyApplicationsQuery,
    useUpdateThirdPartyApplicationMutation,
    useLazyGetThirdPartyApplicationDetailByAppIdQuery,
    useLazyGetListThirdPartyAppWisePropertyMapByAppIdQuery,
    useDeleteThirdPartyAppWisePropertyMapMutation,
    useGetPropertyTypeListQuery,
    useLazyGetPropertyListByPropertyTypeIdQuery,
    useAddThirdPartyAppWisePropertyMapMutation,
    useLazyGetAllPatternsQuery,
    useAddNewPatternMutation,
    useUpdatePatternMutation
} = configurationAPI;

export default configurationAPI;